import { AdSet } from '../../entities/ad-set';
import { IntegrationInterface } from '../../interfaces/components/integrations/IntegrationInterface';
import { Injectable, MultiInject, Optional } from '../dependency-injection/decorators';
import { Events } from '../event-manager/event/events';
import { IntegrationLifecycleEvent } from '../event-manager/event/integration-lifecycle.event';
import { EventManager } from '../event-manager/event-manager';
import { Logger } from '../logger/logger';

@Injectable()
export class IntegrationRunner {
  public constructor (
    @MultiInject('Integration') private readonly integrations: IntegrationInterface[],
    private readonly eventManager: EventManager,
    @Optional() private readonly logger?: Logger,
  ) {
  }

  public async run (adSet: AdSet): Promise<void> {
    for (const integration of this.integrations) {
      if (!integration.supports(adSet)) {
        continue;
      }

      const event = await this.eventManager.dispatch(
        Events.INTEGRATION_PRE_RUN,
        new IntegrationLifecycleEvent(adSet, integration),
      );

      if (event.isPropagationStopped()) {
        // if the event is stopped, we should skip this integration
        continue;
      }

      try {
        await (event.getIntegration().run(adSet));
        await this.eventManager.dispatch(
          Events.INTEGRATION_POST_RUN,
          new IntegrationLifecycleEvent(adSet, integration),
        );
      } catch (error) {
        this.logger?.error(`Integration ${event.getIntegration().constructor.name} failed to run`, error);
        throw error;
      }
    }
  }
}
